export default __webpack_public_path__ + "static/media/IMG_Main_car.bc7a24b3.png";